import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth'
import permit from './permit'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth:auth,
    permit:permit,
  }
})